<div class="table-container">
  <table mat-table [dataSource]="tasks" class="home-patient-list">
    <!-- Task Name Column -->
    <ng-container matColumnDef="task_name">
      <th mat-header-cell *matHeaderCellDef>{{ 'WORKFLOW.task_name' | translate }}</th>
      <td mat-cell *matCellDef="let task">{{ task.data.task_name }}</td>
    </ng-container>

    <!-- Description Column -->
    <ng-container matColumnDef="details">
      <th mat-header-cell *matHeaderCellDef>{{ 'WORKFLOW.details' | translate }}</th>
      <td mat-cell *matCellDef="let task">{{ task.data.details }}</td>
    </ng-container>

    <!-- Goal Date Column -->
    <ng-container matColumnDef="goalDateOn">
      <th mat-header-cell *matHeaderCellDef>{{ 'WORKFLOW.goalDateOn' | translate }}</th>
      <td mat-cell *matCellDef="let task">{{ task.data.goalDateOn | date: 'dd.MM.yy' }}</td>
    </ng-container>

    <!-- Priority -->
    <ng-container matColumnDef="priority">
      <th mat-header-cell *matHeaderCellDef>{{ 'WORKFLOW.priority' | translate }}</th>
      <td mat-cell *matCellDef="let task">
        {{ 'GENERAL.priority_' + task.data.priority | translate }}
      </td>
    </ng-container>

    <!-- Contractor -->
    <ng-container matColumnDef="contractor">
      <th mat-header-cell *matHeaderCellDef>{{ 'WORKFLOW.contractor' | translate }}</th>
      <td mat-cell *matCellDef="let task">
        {{ task.data.contractor?.first_name }} {{ task.data.contractor?.last_name }}
      </td>
    </ng-container>

    <!-- Done Status Column -->
    <ng-container matColumnDef="done">
      <th mat-header-cell *matHeaderCellDef>{{ 'WORKFLOW.done' | translate }}</th>
      <td mat-cell *matCellDef="let task">
        <div class="status-indicator" [class.completed]="task.data.done"></div>
      </td>
    </ng-container>

    <!-- Table Header -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

    <!-- Table Row -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onRowClicked(row)"></tr>
  </table>
</div>
